import { Dispatch } from "redux";
import api from "../../api/api";
import { setAverageScore } from "../reducers/getOverallPerformanceScoreByTeacherReducer";

const getOverallPerformanceScoreByStudent = (token: any, data: any) => async (
    dispatch: Dispatch
) => {

    try {

        const result = await api.get(`/analytics/dashboard/student/get-average-score/`, {
            params: {
                ...data
            },
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Token ${token}`,
            },
        });

        if (result) {
            //console.warn("graph result by students:", result.data);
            dispatch(setAverageScore(result?.data || []))


            //dispatch(setloading(false));
            if (result.data?.status === 200) {
                //dispatch(setCourseList(result.data.data));
                //dispatch(setPagination(result.data));
            } else {
                //dispatch(seterror(result.data?.message ?? "Something Went Wrong!"));
            }
        }
    } catch (error: any) {
        // dispatch(setloading(false));
        console.error("Error fetching course list:", error);
    }
}

//};

//export { getAllCoursesByTeacherId, resetCourseList };
export { getOverallPerformanceScoreByStudent };


